export default __webpack_public_path__ + "static/media/messageIcon.76dce6dd.svg";